/**
 * The named movements of the booking site, and only these (TDD-SA FR-SA-200, design note
 * salon-booking-premium-redesign.md section 5.4): `rise`, `fade`, `stagger`, `settle`, `slide`,
 * `countUp` and `marquee`. One easing everywhere, the same curve as `--ease-soft` in app.css.
 * Nothing loops except the marquee.
 */
export const EASE = [0.2, 0.7, 0.2, 1] as const;

/** Between siblings that arrive together: cards in a grid, words in a headline. */
export const STAGGER_MS = 60;

/** A shared-layout indicator gliding between choices (the navigation, the selected day). */
export const SLIDE = { type: "spring", stiffness: 420, damping: 38, mass: 0.8 } as const;

/** Content swapping in place (a testimonial, a step). */
export const FADE = { duration: 0.35, ease: EASE } as const;
